import { createFileRoute } from "@tanstack/react-router";
import { PortalSenderDetailV2Page } from "@/components/v2/pages/portal-sender-detail-v2-page";

export const Route = createFileRoute("/portal/senders/$sourceIp")({
  component: PortalSenderDetailV2Page,
});
